import { cva } from 'class-variance-authority'

export const carouselDotVariants = cva(
  'relative m-2 cursor-pointer rounded-full border-black border-2',
  {
    variants: {
      size: {
        default: 'size-[11px] border-2',
      },
      variant: {
        default: 'border-black',
      },
      state: {
        active: 'active',
        inactive: 'inactive',
      },
    },
    compoundVariants: [
      {
        variant: 'default',
        state: 'active',
        class: 'bg-black border-black',
      },
      {
        variant: 'default',
        state: 'inactive',
        class: 'bg-white border-black',
      },
    ],
    defaultVariants: {
      size: 'default',
      variant: 'default',
    },
  }
)
